import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemStock\GetItemForStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemForStockController.php
* @route '/api/stock/item/{item}'
*/
const GetItemForStockController = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemForStockController.url(args, options),
    method: 'get',
})

GetItemForStockController.definition = {
    methods: ["get","head"],
    url: '/api/stock/item/{item}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemStock\GetItemForStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemForStockController.php
* @route '/api/stock/item/{item}'
*/
GetItemForStockController.url = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: args.item,
    }

    return GetItemForStockController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemStock\GetItemForStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemForStockController.php
* @route '/api/stock/item/{item}'
*/
GetItemForStockController.get = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemForStockController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemStock\GetItemForStockController::__invoke
* @see app/Http/Controllers/ItemStock/GetItemForStockController.php
* @route '/api/stock/item/{item}'
*/
GetItemForStockController.head = (args: { item: string | number } | [item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemForStockController.url(args, options),
    method: 'head',
})

export default GetItemForStockController